function SemPermissao() {

  return (
    <div style={{ height: '60vh', justifyContent: 'center', display: 'flex', marginTop: '10%', color: 'red', fontWeight: 'bold', fontSize: '25px' }}>
      Você não tem permissão para acessar essa p&aacute;gina!
    </div>
  );
}

export default SemPermissao;